<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Location</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-1">
            <h4 class="mt-2">Company</h4>
          </div>
          <div class="col-md-5 fit-content">
            <select class="form-control" v-model="company" @change="changeCompany">
              <option v-for="company in companies" :key="company.CompanyName" :value="company.CompanyName">
                {{ company.CompanyName }}
              </option>
            </select>
          </div>
        </div>

        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <form id="saveForm" @submit.prevent="save"></form>
          <table style="width: auto !important" class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 150px">Location Code</th>
                <th class="text-center" style="width: 300px">Location Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(loc, i) in locations" :key="loc.Id">
                <td class="text-center">
                  <input form="saveForm" type="text" v-model="loc.LocationCode"
                    class="form-control height26 text-center" required />
                </td>
                <td class="text-center" style="position: relative">
                  <input form="saveForm" type="text" v-model="loc.LocationName"
                    class="form-control height26 text-center" required />
                  <span @click="removeLocation(i)" style="
                      position: absolute;
                      right: -8px;
                      top: 6px;
                      color: #ff0000;
                      cursor: pointer;
                    ">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr v-for="(newLoc, i) in newLocations" :key="i">
                <td class="text-center">
                  <input form="saveForm" type="text" v-model="newLoc.LocationCode"
                    class="form-control height26 text-center" required />
                </td>
                <td class="text-center" style="position: relative">
                  <input form="saveForm" type="text" v-model="newLoc.LocationName"
                    class="form-control height26 text-center" required />
                  <span @click="removeNewLocation(i)" style="
                      position: absolute;
                      right: -8px;
                      top: 6px;
                      color: #ff0000;
                      cursor: pointer;
                    ">
                    <i class="fa fa-minus-circle"></i>
                  </span>
                </td>
              </tr>

              <tr>
                <td class="text-center" colspan="2">
                  <button type="button" class="btn btn-primary" @click="addLocation">
                    <i class="fa fa-plus"></i> Add Location
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <button form="saveForm" type="submit" class="btn btn-primary">
              <i class="fa fa-save"></i>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      company: config.COMPANY_LAMR,
      companies: [],
      locations: [],
      newLocations: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    addLocation() {
      this.newLocations.push({
        Id: "",
        LocationCode: "",
        LocationName: "",
      });
    },
    removeNewLocation(index) {
      this.newLocations.splice(index, 1);
    },
    removeLocation(index) {
      this.locations.splice(index, 1);
    },
    changeCompany() {
      this.getLocations();
    },
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            this.company = this.companies[0].CompanyName;
            this.getLocations();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getLocations() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getLocations(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) this.locations = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //check duplicate location code
      let allLocations = this.locations.concat(this.newLocations);
      for (let item of allLocations) {
        if (item.LocationCode) {
          let records = allLocations.filter(
            (c) => c.LocationCode == item.LocationCode
          );
          if (records && records.length > 1) {
            alert(`Location Code: ${item.LocationCode} is duplicated.`);
            return;
          }
        }
      }

      let param = {
        Token: this.token,
        Company: this.company,
        Locations: this.locations,
        NewLocations: this.newLocations,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the location?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveLocations(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.locations = [];
              this.newLocations = [];
              this.getLocations();
            })
            .catch((error) => {
              console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
    this.getCompanies();
    this.getLocations();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
</style>


// WEBPACK FOOTER //
// src/components/System/Location.vue